import {
  LayoutGrid,
  CreditCard,
  ArrowDownToLine,
  UserPlus,
  Users,
  Receipt,
  HelpCircle,
  Settings,
  Sun,
} from "lucide-react";

// ============================================================
// VIP LEVELS
// ============================================================

export const vipLevels = [
  { id: 1, deposit: 50, daily: 5, color: "#5B8DEF" },
  { id: 2, deposit: 100, daily: 10, color: "#3FBF8F" },
  { id: 3, deposit: 300, daily: 30, color: "#E0A63C" },
  { id: 4, deposit: 500, daily: 55, color: "#9067E8" },
  { id: 5, deposit: 800, daily: 90, color: "#E5566B" },
  { id: 6, deposit: 1200, daily: 140, color: "#2FB6A6" },
  { id: 7, deposit: 1800, daily: 220, color: "#E08A3C" },
  { id: 8, deposit: 2500, daily: 320, color: "#4C9BE8" },
  { id: 9, deposit: 3500, daily: 460, color: "#7B6DE8" },
  { id: 10, deposit: 5000, daily: 700, color: "#E5566B" },
];

// ============================================================
// SIDEBAR NAVIGATION
// ============================================================

export const navItems = [
  {
    icon: LayoutGrid,
    label: "Dashboard",
    path: "/",
  },
  {
    icon: CreditCard,
    label: "Payment Method",
    path: "/request-points",
    children: [
      {
        icon: CreditCard,
        label: "Add Payment",
        path: "/request-points",
      },
      {
        icon: ArrowDownToLine,
        label: "Withdraw",
        path: "/withdraw",
      },
    ],
  },
  {
    icon: Receipt,
    label: "Activities",
    path: "/transactions",
  },
  {
    icon: UserPlus,
    label: "Referrals",
    path: "/referrals",
  },
  {
    icon: HelpCircle,
    label: "Support",
    path: "/support",
  },
  {
    icon: Settings,
    label: "Settings",
    path: "/settings",
  },
];

// ============================================================
// RECENT TRANSACTIONS
// ============================================================

export const recentTx = [
  {
    type: "Deposit",
    date: "May 26, 2025 09:15 AM",
    amount: "+300.00",
    status: "Completed",
  },
  {
    type: "Daily Earning",
    date: "May 26, 2025 12:00 AM",
    amount: "+30.00",
    status: "Completed",
  },
  {
    type: "Referral Bonus",
    date: "May 25, 2025 08:45 PM",
    amount: "+15.00",
    status: "Completed",
  },
  {
    type: "Withdraw",
    date: "May 24, 2025 03:10 PM",
    amount: "-100.00",
    status: "Completed",
  },
  {
    type: "Daily Earning",
    date: "May 24, 2025 12:00 AM",
    amount: "+30.00",
    status: "Completed",
  },
];

// ============================================================
// HOW IT WORKS
// ============================================================

export const howItWorks = [
  {
    icon: UserPlus,
    title: "Choose VIP Level",
    desc: "Select a VIP level that fits your plan.",
  },
  {
    icon: CreditCard,
    title: "Make Deposit",
    desc: "Deposit the required amount to activate.",
  },
  {
    icon: Sun,
    title: "Earn Daily",
    desc: "Start earning daily rewards automatically.",
  },
  {
    icon: Users,
    title: "Invite & Earn More",
    desc: "Invite friends and earn extra rewards.",
  },
];

// ============================================================
// REFERRALS
// ============================================================

export const referrals = [
  {
    name: "Ahmed Raza",
    date: "May 20, 2025",
    earned: "50.00",
    status: "Active",
  },
  {
    name: "Sara Khan",
    date: "May 18, 2025",
    earned: "30.00",
    status: "Active",
  },
  {
    name: "Bilal Hussain",
    date: "May 10, 2025",
    earned: "0.00",
    status: "Pending",
  },
];

// ============================================================
// TEAM MEMBERS
// ============================================================

export const teamMembers = [
  {
    name: "Ahmed Raza",
    level: "VIP 3",
    joined: "May 20, 2025",
    earnings: "90.00",
  },
  {
    name: "Sara Khan",
    level: "VIP 2",
    joined: "May 18, 2025",
    earnings: "45.00",
  },
  {
    name: "Bilal Hussain",
    level: "VIP 1",
    joined: "May 10, 2025",
    earnings: "15.00",
  },
  {
    name: "Ayesha Malik",
    level: "VIP 4",
    joined: "May 5, 2025",
    earnings: "165.00",
  },
];

// ============================================================
// EARNINGS
// ============================================================

export const earningsBreakdown = [
  {
    label: "Daily Earnings",
    amount: "255.00",
    color: "#3FBF8F",
  },
  {
    label: "Referral Bonus",
    amount: "50.00",
    color: "#5B8DEF",
  },
  {
    label: "Team Bonus",
    amount: "15.75",
    color: "#9067E8",
  },
];

// ============================================================
// USERS
// ============================================================

export const allUsers = [
  {
    id: 1,
    name: "Umair Jamil",
    email: "umair@example.com",
    vip: "VIP 3",
    balance: "1,250.00",
    status: "Active",
    joined: "May 1, 2025",
  },
  {
    id: 2,
    name: "Ahmed Raza",
    email: "ahmed@example.com",
    vip: "VIP 3",
    balance: "620.00",
    status: "Active",
    joined: "May 20, 2025",
  },
  {
    id: 3,
    name: "Sara Khan",
    email: "sara@example.com",
    vip: "VIP 2",
    balance: "310.00",
    status: "Active",
    joined: "May 18, 2025",
  },
  {
    id: 4,
    name: "Bilal Hussain",
    email: "bilal@example.com",
    vip: "VIP 1",
    balance: "50.00",
    status: "Pending",
    joined: "May 10, 2025",
  },
  {
    id: 5,
    name: "Ayesha Malik",
    email: "ayesha@example.com",
    vip: "VIP 4",
    balance: "980.00",
    status: "Active",
    joined: "May 5, 2025",
  },
  {
    id: 6,
    name: "Zainab Fatima",
    email: "zainab@example.com",
    vip: "VIP 1",
    balance: "50.00",
    status: "Suspended",
    joined: "April 28, 2025",
  },
];

// ============================================================
// ADMIN STATS
// ============================================================

export const adminStats = {
  totalUsers: 1284,
  totalDeposits: "182,400.00",
  totalWithdrawals: "64,120.00",
  activeVipUsers: 742,
};

// ============================================================
// PENDING WITHDRAWALS
// ============================================================

export const pendingWithdrawals = [
  {
    id: 1,
    user: "Bilal Hussain",
    amount: "100.00",
    requested: "May 27, 2025 10:00 AM",
  },
  {
    id: 2,
    user: "Sara Khan",
    amount: "50.00",
    requested: "May 27, 2025 09:15 AM",
  },
];